import * as angular from 'angular';
import template from './tiamaConfig.tpl.html';
import {ConfigScope} from "./config.base";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";

interface TiamaConfigScope extends ConfigScope {
  equipment: apsViewModels.EquipmentDetail[];
  versions: EnumOption[];
}

export default angular.module('aps.controller.tiamaConfig', [])
  .directive('tiamaConfig', (uiUtilityService: UIUtilityService): angular.IDirective => {
    return {
      restrict: 'E',
      template: template,
      link: (scope: TiamaConfigScope) => {
        scope.equipment = scope.vm.allEquipment.filter(e => e.type === apsEnums.EquipmentType.Mcal);
        scope.versions = uiUtilityService.getListOptionsFromEnum(apsEnums.TiamaMultiMcalProtocol);
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/tiamaConfig.directive.ts